<div class="el-pricing-wrapper">
    <div class="container">
        <div class="el-team-heading text-center pb-3">
            <h4 class="el-top-heading-center">PowerPrep Plans</h4>
        </div>
        <div class="d-flex justify-content-center" *ngIf="IsShowMessage">
            <div class="col-md-5 alert">
                <i class="fa fa-exclamation-triangle" aria-hidden="true" style="font-size: 50px;color: #e04787;"></i>
                <br><br>
                Not available for: <strong *ngIf="PREP_UserInfo.classId <= '12'">Class
                    {{PREP_UserInfo.classId}}</strong> <strong *ngIf="PREP_UserInfo.classId > '12'">Class
                    {{PREP_UserInfo.className}} </strong>

            </div>
        </div>
        <div *ngIf="SubjectList.length>0" class="el-pricing-main-parent">

            <div class="row">
                <div class="d-flex justify-content-center align-items-center mb-3" *ngIf="PREP_UserInfo?.classId==null">
                    <div class="el-banner-form-info">
                        <select class="form-control " [(ngModel)]="classId" (change)="Change_Class()"
                            style="height: 50px; background-color: transparent; border: 1px solid #e04787;">
                            <option *ngFor="let _obj of ClassList" [ngValue]="_obj.classId">
                                {{ _obj.className }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="el-pricing-btn">
                    <ul id="myTab" role="tablist" class="nav nav-tabs mb-4">
                        <li class="nav-item" *ngFor="let subject of SubjectList">
                            <button class="nav-link" [ngClass]="{'active': selectedSubject === subject.subjectName}"
                                (click)="onSubjectChange(subject.subjectName)">
                                {{ subject.subjectName }}
                            </button>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- Dynamic tab content for selected subject -->
            <div class="tab-content mt-3">
                <div class="tab-pane fade show active">
                    <ng-container
                        *ngTemplateOutlet="planBlock; context: { $implicit: filterBySubject(selectedSubject) }">
                    </ng-container>
                </div>
            </div>

            <ng-template #planBlock let-plans>

                <div class="row gy-4 d-flex justify-content-start ">
                    <div class="col-lg-4 col-md-6 " *ngFor="let plan of plans">

                        <div class="el-price-box ">

                            <div class="ribbon ribbon-top-left" *ngIf="plan.plan=='2'"><span>{{
                                    FrequentlyPurchased(plan.plan)}}</span></div>
                            <div class="el-price-inner">
                                <!-- <h5>{{ FrequentlyPurchased(plan.plan)}}</h5> -->
                                <h4 class="el-popular-plan">{{plan.discount}} % discount</h4>
                                <div class="el-price-head">
                                    <div class="el-price-img d-flex justify-content-between align-items-center p-4">
                                        <div style="flex-direction: column;">
                                            <h4>Phase {{ plan.plan }}</h4>
                                            <strong class="el-para color-theme">{{ getPlansubtitle(plan.plan)}}</strong>
                                        </div>

                                        <!-- <img src="../assets/images/all-instructor/reg.png" alt="icon" width="100px"> -->

                                        <img [src]="plan.bookImage" alt="icon" width="100px">


                                    </div>
                                    <!-- <p class="el-para">{{ plan.description || 'For an individual and beginner' }}</p> -->
                                    <div class="strip-text">
                                        <p class="el-para">{{ getPlanMessage(plan.plan) }}</p>
                                    </div>
                                    <h1>₹ {{ plan.priceAfterDiscount }}
                                        <span><del> ₹ {{ plan.price }} </del> /Year</span>

                                    </h1>

                                    <!-- <a href="javascript:;" class="el-btn" (click)="AddNow(plan, selectedSubject)">Get
                                        Started Now</a> -->
                                    <!-- <a href="javascript:;" class="el-btn" style="background-color: #f0f0f0;color: #e04787;
                                     pointer-events:auto;
                                     opacity: 1
                                      " (click)="!addedItems.has(plan.bookId) && AddNow(plan)">
                                        {{ addedItems.has(plan.bookId) ? 'Added' : 'Get Started Now' }}
                                    </a> -->

                                    <a href="javascript:;" class="el-btn" [ngStyle]="{'background-color': plan.isPurchased  ? '#5c0090': (addedItems.has(plan.bookId)) ? '#28a745' :'#e04787','color': '#ffffff',

                                     'pointer-events': addedItems.has(plan.bookId) ? 'none' : 'auto',
                                     'opacity': addedItems.has(plan.bookId) ? '0.7' : '1'
                                      }"
                                        (click)="(_buttonText(plan)!='Added'&& _buttonText(plan)!='Purchased') && AddNow(plan)">

                                        {{ _buttonText(plan)}}
                                        <!-- &nbsp;<i *ngIf="addedItems.has(plan.bookId)" class="fa fa-shopping-bag "></i>-->
                                        <div class="success-animation m-0" *ngIf="addedItems.has(plan.bookId)">
                                            <svg class="checkmark" xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 52 52">
                                                <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
                                                <path class="checkmark__check" fill="none"
                                                    d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                                            </svg>
                                        </div>
                                    </a>



                                </div>
                                <div class="el-pricing-list">
                                    <ul>
                                        <li class="el-para" *ngIf="plan.plan !=4"><i
                                                class="fa fa-check-circle"></i><span>

                                                {{plan.descriptions}}

                                            </span></li>

                                        <li class="el-para" *ngIf="plan.mockCount >0"><i
                                                class="fa fa-check-circle"></i><span>{{plan.mockCount}}</span> Mock

                                            Tests</li>

                                    </ul>


                                    <div *ngIf="plan.eBooks!=null">
                                        <ul *ngFor="let ebook of plan.eBooks.split('<br>')">
                                            <li class="el-para">

                                                <i class="fa fa-check-circle"></i> <span> {{ebook}}</span>
                                            </li>
                                        </ul>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="plans.length === 0" class="text-center text-danger w-100">
                        No plans available for this subject in Class {{ classId }}.
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
</div>